<template>
    <v-container>
        <v-layout row wrap>
            <v-flex md8>
                <h2>De Cell[0] Inspiratietuin</h2>
                <p>
                    Welkom in de Inspiratietuin van Cell[0]. Hier vind je onze experimenten met technieken,
                    features en concepten die we zó leuk vinden dat we ze niet voor ons zelf willen houden.
                </p>
                <p>
                    Op onze LinkedIn pagina vind je de bijbehorende blog-reeks van Diede Gulpers, waarin hij
                    meer vertelt over de achtergrond van wat we hier demonstreren.
                </p>
                <p>
                    Veel plezier,
                    <br />
                    Het Cell[0] team
                </p>
                <v-btn target="_blank" href="https://www.linkedin.com/company/cell-0-/" class="ml-0 mb-4" color="primary">
                    <v-icon class="mr-2">link</v-icon>
                    Lees de blog
                </v-btn>
                <v-btn target="_blank" href="https://cell-0.com" class="ml-0 mb-4" >
                    <v-icon class="mr-2">home</v-icon>
                    Bezoek onze website
                </v-btn>
            </v-flex>
            <v-flex md4 mb-5>
                <install-card />
            </v-flex>
        </v-layout>

        <v-list three-line>
            <div v-for="demo in demos" :key="demo.component">
                <v-list-tile avatar ripple :to="{ name: 'demos', params: { demo: demo.component } }">
                    <v-list-tile-avatar>
                        <v-icon>{{ demo.icon || 'star' }}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ demo.name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ demo.description }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider />
            </div>
        </v-list>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import InstallCard from './InstallCard'

export default {
    components: {
        InstallCard,
    },
    computed: {
        ...mapGetters([
            'logo',
            'demos',
        ]),
    },
}
</script>
